/**
 * [CurveBeamAI] Workflow preset registry.
 *
 * Maps workflow ID strings to their preset configuration objects.
 * To add a new workflow: create a preset file, import it here, and add to the map.
 */

import { WorkflowPreset, WorkflowId } from './types';
import { viewPreset } from './view/preset';
import { patientPreset } from './patient/preset';
import { reviewPreset } from './review/preset';
import { bonevueRotatePreset } from './bonevue/rotate/preset';
import { bonevueSegmentationPreset } from './bonevue/segmentation/preset';
import { defaultPreset } from './default/preset';

export const workflowPresetRegistry = new Map<WorkflowId, WorkflowPreset>([
  ['view', viewPreset],
  ['patient', patientPreset],
  ['review', reviewPreset],
  ['bonevue-rotate', bonevueRotatePreset],
  ['bonevue-segmentation', bonevueSegmentationPreset],
  ['default', defaultPreset],
]);
